export { Text } from "native-base";
